/********************************************************************
 * @author:      Kaven
 * @email:       kaven@wuwenkai.com
 * @website:     http://blog.kaven.xyz
 * @file:        [Kaven-Basic] /src/libs/data/GetInvalidFileNameCharsUnix.ts
 * @create:      2025-07-03 15:42:03.024
 * @modify:      2025-07-11 21:19:12.970
 * @version:     6.0.0
 * @times:       6
 * @lines:       48
 * @copyright:   Copyright © 2018-2025 Kaven. All Rights Reserved.
 * @description: [description]
 * @license:
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 ********************************************************************/

/**
 * Returns an array of characters that are invalid in Unix file names.
 *
 * On Unix-based systems, the only invalid characters in file names are the null character (`\0`)
 * and the forward slash (`/`), which is used as a directory separator.
 *
 * @returns {string[]} An array containing the invalid file name characters for Unix systems.
 *
 * @since 4.0.0
 * @version 2021-12-09
 */
export function GetInvalidFileNameCharsUnix(): string[] {
    // https://github.com/dotnet/runtime/blob/b2dc37ba181a7fa4427e717eab819ba3543d0ae4/src/libraries/System.Private.CoreLib/src/System/IO/Path.Unix.cs#L12
    return ["\0", "/"];
}
